import AppDispatcher from '../dispatcher/AppDispatcher';
import { EventEmitter } from 'events';
import { CHANGE_EVENT } from '../constants/AppConstants';
import { UPDATE_CURRENT_MESSAGE } from '../constants/AccessibilityConstants';

let currentMessage = '';

class AccessibilityStore extends EventEmitter {
  constructor() {
    super();
    this.dispatchToken = AppDispatcher.register(
      this.dispatcherCallback.bind(this)
    );
  }
  emitChange() {
    this.emit(CHANGE_EVENT);
  }

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }

  getCurrentMessage() {
    return currentMessage;
  }

  dispatcherCallback(data) {
    const action = data.action;
    if (action.actionType === UPDATE_CURRENT_MESSAGE) {
      currentMessage = action.data;
      this.emitChange();
    }
  }
}

export default new AccessibilityStore();
